import React from "react";

interface InformationalNoteProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * InformationalNote
 * A reusable component for displaying informational notes with consistent styling.
 * Used throughout forms to provide important information to users.
 */
export const InformationalNote: React.FC<InformationalNoteProps> = ({
  children,
  className = "",
}) => {
  return (
    <div
      className={`p-4 bg-blue-50 border border-blue-200 rounded-lg ${className}`}
    >
      <p className="text-sm text-blue-800">{children}</p>
    </div>
  );
};

